import get from 'lodash/get';

export const calculateDiscount = (option) => {
  const { promotions } = option;
  const price = promotions && promotions.length === 1
    ? get(promotions[0], 'basePriceReduction', 0)
    : 0;

  return Number(price).toFixed(2);
};

export const calculatePrice = (option) => {
  const { priceWithVat, promotions } = option;
  const price = promotions && promotions.length === 1
    ? parseFloat(priceWithVat) - parseFloat(get(promotions[0], 'basePriceReduction', 0))
    : 0;

  return Number(price).toFixed(2);
};
